import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import { SiteDocument } from '../Site/queryBuilder';
import { DailySafetyTopicDocument, dailySafetyTopicsPullQueryBuilder } from './queryBuilder';

export function dailySafetyTopicFamilyMember(
  configBuilder: ConfigBuilder,
  sites: FamilyMember<SiteDocument>,
): FamilyMember<DailySafetyTopicDocument> {
  const syncConfig = configBuilder<DailySafetyTopicDocument>(
    RxdbCollectionNameV2.DAILY_SAFETY_TOPIC,
  );
  doNotAutoSync(syncConfig);

  pull(syncConfig, dailySafetyTopicsPullQueryBuilder);

  const replicationState = replicate(syncConfig);
  // Legacy had the syncInterval at LiveInterval.MINUTES_15
  return create(RxdbCollectionNameV2.DAILY_SAFETY_TOPIC, replicationState, [sites]);
}
